import ClientService from '@boServices/clientService';
import { useEffect, useState } from 'react';

const clientService = new ClientService();

// Largest page of GET /clients.
const PER_PAGE = 100;

// Every active client, page after page until the total of rows; an empty page ends the loading early. A client
// read on two pages, which an order without tie-breaker allows, is kept once.
const loadActiveClients = async (signal) => {
    const clients = new Map();
    let fetched = 0;
    let total = 0;
    let page = 1;
    do {
        const data = await clientService.getClients({ activeOnly: true, perPage: PER_PAGE, page, signal });
        const items = data.items ?? [];
        if (items.length === 0) break;
        items.forEach((client) => clients.set(client.uuid, client));
        fetched += items.length;
        total = data.total ?? 0;
        page += 1;
    } while (fetched < total);
    return [...clients.values()];
};

// Active clients offered by the client filter of the collection list, loaded once; the loading is cancelled on
// unmount. A failed request leaves the list empty.
const useClientFilterOptions = () => {
    const [clients, setClients] = useState([]);

    useEffect(() => {
        const controller = new AbortController();
        loadActiveClients(controller.signal)
            .then((loaded) => {
                if (!controller.signal.aborted) setClients(loaded);
            })
            .catch(() => {});
        return () => controller.abort();
    }, []);

    return { clients };
};

export default useClientFilterOptions;
